import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { CommonToastComponent } from "./common/common-toast/common-toast.component";

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, CommonToastComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'ISDirectory';
}
